<template>
  <div>
    <div class="simpleStorageServiceResourceAzure-title">
      <div>{{ $t("RAM.Azure.storageAccount.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:azure:simpleStorageServiceResourceAzure:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          :loading="modal_loading"
          @click="exportList"
          v-hasPermission="[
            'resourceConfigurationManagement:azure:simpleStorageServiceResourceAzure:export'
          ]"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="simpleStorageServiceResourceAzure-top">
      <simple-storage-service-resource-azure-search
        ref="search"
      ></simple-storage-service-resource-azure-search>
    </div>
    <table-simple-storage-service-resource-azure></table-simple-storage-service-resource-azure>
  </div>
</template>

<script>
import SimpleStorageServiceResourceAzureSearch from "../s3/SimpleStorageServiceResourceAzureSearch";
import TableSimpleStorageServiceResourceAzure from "../s3/TableSimpleStorageServiceResourceAzure";

export default {
  name: "SimpleStorageServiceResourceAzure",
  components: {
    SimpleStorageServiceResourceAzureSearch,
    TableSimpleStorageServiceResourceAzure
  },
  data() {
    return {
      loading: false,
      modal_loading: false,
      companyId: "",
      name: ""
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.companyId = this.$refs.search.companyId;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 205
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success("更新成功");
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });
      this.companyId = this.$refs.search.companyId;
      this.name = this.$refs.search.name;
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAzureStorageAccounts({
          companyId: this.companyId,
          name: this.name
        })
        .then(res => {
          let fileName = "存储账户.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success("导出成功");
        });
    }
  }
};
</script>

<style scoped>
.simpleStorageServiceResourceAzure-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.simpleStorageServiceResourceAzure-title > div:nth-child(1) {
  float: left;
}
.simpleStorageServiceResourceAzure-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.simpleStorageServiceResourceAzure-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/azure/s3/SimpleStorageServiceResourceAzure.vue